import { Injectable, TemplateRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  toasts: any[] = [];

  constructor(private translateService: TranslateService) { }

  // Push new Toasts to array with content and custom options
  show(textOrTpl: string | TemplateRef<any>, options: any = {}) {
    if (typeof textOrTpl === 'string') {
      textOrTpl = this.translateService.instant(textOrTpl);
    }
    this.toasts.push({ textOrTpl, ...options });
  }

  // Push new Error Toasts to array with content and custom options
  showError(textOrTpl: string | TemplateRef<any>, options: any = {}) {
    if (typeof textOrTpl === 'string') {
      textOrTpl = this.translateService.instant(textOrTpl);
    }
    options = {
      classname: 'cc-alert-danger cc-alert ',
      delay: 5000,
      autohide: true,
    };
    this.show(textOrTpl, options);
  }

  // Push new Success Toasts to array with content and custom options
  showSuccess(textOrTpl: string | TemplateRef<any>) {
    if (typeof textOrTpl === 'string') {
      textOrTpl = this.translateService.instant(textOrTpl);
    }
    let options = {
      classname: 'cc-alert-success cc-alert',
      delay: 2000,
      autohide: true,
    };
    this.show(textOrTpl, options);
  }

  // Push new Info Toasts to array with content and custom options
  showInfo(textOrTpl: string | TemplateRef<any>) {
    if (typeof textOrTpl === 'string') {
      textOrTpl = this.translateService.instant(textOrTpl);
    }
    let options = {
      classname: 'cc-alert-info cc-alert',
      delay: 2000,
      autohide: true,
    };
    this.show(textOrTpl, options);
  }

  // Callback method to remove Toast DOM element from view
  remove(toast: string | TemplateRef<any>) {
    this.toasts = this.toasts.filter(t => t !== toast);
  }
}